module.exports = __webpack_public_path__ + "static/media/RADHome.73884437.png";